module.exports = __webpack_public_path__ + "img/CM-MC-25-Audi-Established.c2f2bac8.jpg";